import { useState, useEffect, useRef } from "react";

const QUOTES = [
  "Your training. Your transformation.",
  "Discipline builds what motivation starts.",
  "Stronger every day. One rep at a time.",
  "Progress is earned through consistency.",
  "Show up today. Be proud tomorrow.",
  "Small steps. Stronger results.",
  "Consistency creates confidence.",
  "Small daily wins create massive transformations.",
  "Focus on the process, results will follow.",
];

export default function RotatingQuote() {
  const [index, setIndex] = useState(0);
  const [fadeState, setFadeState] = useState("in"); // "in" | "out"
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const prefersReducedMotion =
      typeof window !== "undefined" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const stopTimers = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };

    const startTimer = () => {
      stopTimers();
      intervalRef.current = setInterval(() => {
        if (prefersReducedMotion) {
          setIndex((prev) => (prev + 1) % QUOTES.length);
        } else {
          setFadeState("out");
          timeoutRef.current = setTimeout(() => {
            setIndex((prev) => (prev + 1) % QUOTES.length);
            setFadeState("in");
          }, 450);
        }
      }, 9000); // 9-second rotation interval
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        stopTimers();
      } else {
        startTimer();
      }
    };

    startTimer();
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      stopTimers();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <p
      className={`text-xs sm:text-sm text-slate-400 font-medium transition-opacity duration-500 ease-in-out min-h-[1.25rem] truncate select-none ${
        fadeState === "in" ? "opacity-100" : "opacity-0"
      }`}
      data-testid="welcome-tagline"
      title={QUOTES[index]}
    >
      {QUOTES[index]}
    </p>
  );
}
